/* eslint-disable import/prefer-default-export */
const prefix = 'audits'

export const SET_INITIAL_STATE = `${prefix}/SET_INITIAL_STATE`
export const SET_QUERY = `${prefix}/SET_QUERY`
export const SET_AUDITS_PUBLISHED_DONE_PROGRESS = `${prefix}/SET_AUDITS_PUBLISHED_DONE_PROGRESS`
